import { useEffect } from 'react';
import { useGetNuvemEnvioConfigs } from 'domains/Shipping/DeliveryMethods/hooks';
import LoggiCollectBanner from '../Banners/Loggi';

function ShippingMethodsNEBanners() {
  const { nuvemEnvioConfigs, fetchNuvemEnvioConfigs } =
    useGetNuvemEnvioConfigs();

  useEffect(() => {
    fetchNuvemEnvioConfigs();
  }, [fetchNuvemEnvioConfigs]);

  if (nuvemEnvioConfigs?.displaySwitches?.showLoggiActivationBanner) {
    return <LoggiCollectBanner />;
  }

  return null;
}

export default ShippingMethodsNEBanners;
